/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolioBatchResponse {
    getFixupPrototypeFunction() { return AppSecopsPortfolioBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolioBatchResponse>): AppSecopsPortfolioBatchResponse {
        let obj = Object.assign(new AppSecopsPortfolioBatchResponse(), model);
        AppSecopsPortfolioBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolioBatchResponse>): AppSecopsPortfolioBatchResponse {
        if (!model) return null;
        return AppSecopsPortfolioBatchResponse.newInstance(<AppSecopsPortfolioBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolioBatchResponse) {
        if (!obj) return;

        models.AppSecopsPortfolioBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolioBatchResponse): boolean {
        Object.setPrototypeOf(obj, AppSecopsPortfolioBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AppSecopsPortfolio.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AppSecopsPortfolio; };

}
